
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["sysManage_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1025 1024","xmlns":"http://www.w3.org/2000/svg","width":"600.586","height":"600"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M665.845 634.736a126.91 126.91 0 10253.82 0 126.91 126.91 0 10-253.82 0zM879.779 792.83h-16.68a168.971 168.971 0 01-145.04 0h-14.504a132.711 132.711 0 00-132.711 132.71v42.062a50.039 50.039 0 0047.863 47.863h350.271a49.314 49.314 0 0047.863-47.863v-42.061A134.887 134.887 0 00879.78 792.829zM135.725 435.305l277.026 145.04a79.047 79.047 0 0145.687 72.52v290.08a91.375 91.375 0 01-136.337 68.893L45.8 866.8A78.321 78.321 0 01.112 791.38v-290.08a91.375 91.375 0 01135.612-65.993zm416.989-422.79L833.366 176.41a91.375 91.375 0 010 156.643L552.714 496.948a87.024 87.024 0 01-89.925 0L182.137 333.053a91.375 91.375 0 010-156.643L462.79 12.515a87.024 87.024 0 0189.925 0z"}})])
          )
        }
      }
    